import API from "../services/apiservices";

export default {
  namespaced: true,
  namespace: "auditStore",

  state: {
    audit: {
      caption: "",
      table: "",
      PK: "",
      FieldName: "",
      success: false,
      data: [],
      erro: ""
    },
    tables: [
      "orcamentosbuilderpedidos",
      "orcamentosbuilderpedidosambientes",
      "pedidos",
    ]
  },

  getters: {
    gtxAudit: (state) => state.audit,
    gtxAuditTables: (state) => state.tables || [],
    gtxAuditCaption: (state) => state.audit.caption,
    gtxAuditTableName: (state) => state.audit.table,
    gtxAuditPK: (state) => state.audit.PK,
    gtxAuditFieldName: (state) => state.audit.FieldName,
    gtxAuditSuccess: (state) => state.audit.success,
    gtxAuditData: (state) => state.audit.data || [],
    gtxAuditErro: (state) => state.audit.erro,
  },

  mutations: {
    setAudit: (state, audit) => (state.audit = {
      caption: audit.caption || "Título padrão",
      table: audit.table,
      PK: audit.PK,
      success: false,
      data: audit.data || [],
      erro: ""
    }),
    setAuditCaption: (state, caption) => (state.audit.caption = caption),
    setAuditTableName: (state, table) => (state.audit.table = table),
    setAuditPK: (state, pk) => (state.audit.PK = pk),
    setAuditFieldName: (state, fieldname) => (state.audit.FieldName = fieldname),
    setAuditData: (state, data) => (state.audit.data = data),
    setAuditSuccess: (state, success) => (state.audit.success = success),
    setAuditErro: (state, erro) => (state.audit.erro = erro),
    setAuditClear: (state) => (state.audit = {
      caption: "",
      table: "",
      PK: "",
      FieldName: "",
      data: [],
      erro: ""
    }),
  },

  actions: {
    actAuditSet({ commit }, audit) { commit('setAudit', audit) },
    actAuditCaption({ commit }, caption) { commit('setAuditCaption', caption) },
    actAuditTableName({ commit }, tablename) { commit('setAuditTableName', tablename) },
    actAuditPK({ commit }, pk) { commit('setAuditPK', pk) },
    actAuditFieldName({ commit }, fieldname) { commit('setAuditFieldName', fieldname) },
    actAuditData({ commit }, data) { commit('setAuditData', data) },
    actAuditDataGet({ commit, getters }) {
      return new Promise((res, rej) => {
        try {
          // a própia API vai cuidar das tabelas permitidas
          //if (getters.gtxAuditTables.find(t => t.toUpperCase() == getters.gtxAuditTableName.toUpperCase()) || getters.gtxAuditTables == []) {
            API.post('Servicos/HistoricoPadrao/Get', getters.gtxAudit, false).then((apidata) => {
              const data = API.prepareData(apidata.data);
              // console.log('actAuditDataGet.data:', data);
              
              commit('setAuditSuccess', data.success);
              commit('setAuditData', []);
              commit('setAuditErro', data.error);

              if (data.success) {
                commit('setAuditData', data.data);
                res(data);
              } else {
                rej(data);
              }
            });
          //} else {
          //  commit('setAuditErro', 'Tabela não permitida para consultas de log');
          //  rej({success: false, erro: 'Tabela não permitida para consultas de log'});
          //}
        } catch (err) {
          rej(err);
        }
      });
    },
    actAuditClear({ commit }) {
      commit('setAuditClear');
    }
  }

}
